import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
  inject,
} from '@angular/core';
import { FormGroup } from '@angular/forms';

import { CustomResult } from 'src/app/core/api/models';
import { EventTypes } from 'src/app/core/constants/event-types';
import { ConsoleService } from 'src/app/core/services/console.service';
import {
  DialogService,
  DialogStatus,
} from 'src/app/core/services/dialog.service';

import { ApiNotificationService } from 'src/app/core/services/api-notification.service';
import { BasePageComponent } from './base-page.component';

//compress text method
declare function compressToEncodedURIComponent(input): any;

@Component({
  selector: 'app-base-form',
  template: ``,
  standalone: false,
})
export abstract class BaseFormPageComponent
  extends BasePageComponent
  implements OnDestroy, OnInit
{
  //#region Properties
  apiNotificationService = inject(ApiNotificationService);
  #dialogService = inject(DialogService);

  formId: string;
  title: string;
  form: FormGroup;
  isVisibleAuditPage: boolean = false;
  fields: string;
  messages: string;
  legends: string;
  model: any;

  resetFormCounter: number = 0;

  baseObserver = {
    next: (result: CustomResult) => {
      this.apiNotificationService.notifyMessage({ result });
      if (result.isSucceed) {
        this.formPageConfig.isEditMode = false;
        this.onSuccess();
      }
    },
    error: (error) => {
      ConsoleService.error('error', error);
    },
    complete: () => (this.loading = false),
  };

  @Output('closeFormPage') output_closeFormPage = new EventEmitter<boolean>();

  //#endregion

  // constructor(
  //   public apiNotificationService: ApiNotificationService,
  // ) {
  //   super();
  // }

  ngOnInit(): void {
    super.ngOnInit();
    this.getUserState();
    this.getVocabs();
    this.initForm();
    this.initModel();
    this.loading = false;
  }

  //#region initializes

  getVocabs() {
    try {
      this.pageVocabs = this.formPageConfig.vocabs;

      this.fields = this.pageVocabs + 'fields.';
      this.messages = this.pageVocabs + 'messages.';
      this.legends = this.pageVocabs + 'legends.';

      if (!this.formPageConfig.title) {
        if (this.formPageConfig.isEditMode)
          this.title = this.pageVocabs + 'editTitle';
        else this.title = this.pageVocabs + 'addTitle';
      }
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.baseFormPage);
    }
  }

  initModel() {
    try {
      // when form is edit mode
      if (this.formPageConfig.isEditMode)
        this.model = JSON.parse(JSON.stringify(this.formPageConfig.editData));
      // when form is create mode
      else this.formPageConfig.editData = {};
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.baseFormPage);
    }
  }

  abstract initForm(): void;

  get errorControl(): any {
    return this.form?.controls;
  }

  //#endregion

  //#region api

  baseCreateApi(model: any) {}

  baseUpdateApi(model: any) {}

  //#endregion

  //#region events

  onSuccess() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'instant',
    });

    this.output_closeFormPage.emit(true);
    this.unSubs();
  }

  onClose() {
    this.loading = false;
    this.formPageConfig.isEditMode = false;
    this.output_closeFormPage.emit(false);

    window.scroll({
      top: 0,
      left: 0,
      behavior: 'instant',
    });

    this.unSubs();
  }

  onShowAuditPage() {
    this.isVisibleAuditPage = true;
  }

  onHideAuditPage() {
    this.isVisibleAuditPage = false;
  }

  onReset() {
    this.resetFormCounter++;
    this.model = {};
    this.initModel();
  }

  //#endregion

  //#region Text Compression

  compressionString(data: string): string {
    try {
      if (!data) return '';
      const compressed = compressToEncodedURIComponent(data);

      return compressed;
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.baseFormPage);
    }
  }

  //#endregion

  checkCreateOrUpdate() {
    if (this.loading || !this.form.valid) return;

    if (this.formPageConfig.isEditMode) this.baseUpdateApi(this.model);
    else this.baseCreateApi(this.model);
  }

  onSubmit() {
    if (this.loading) return;
    if (!this.isValidForm(this.form, this.tagName)) return;

    try {
      this.checkCreateOrUpdate();
    } catch (error) {
      ConsoleService.error('error', error);
      this.loggerService.logError(this.tagName, error, EventTypes.baseFormPage);
    }
  }

  getFormControl(formControlName) {
    return this.form?.get(formControlName);
  }

  isValidForm(
    formGroup: FormGroup,
    parentTagName: string,
    formId?: string
  ): boolean {
    try {
      if (formGroup.valid) return true;

      formGroup.markAllAsTouched();
      let formElement;

      if (formId)
        formElement = document.querySelector(`${parentTagName} #${formId}`);
      else formElement = document.querySelector(`${parentTagName} form`);

      if (formElement) {
        let firstInvalidControl =
          formElement.getElementsByClassName('ng-invalid')[0];
        const yOffset = -170;
        const y =
          firstInvalidControl.getBoundingClientRect().top +
          window.pageYOffset +
          yOffset;
        window.scrollTo({ top: y, behavior: 'smooth' });
      }

      return false;
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.baseFormPage);
    }
  }

  baseCreateGetApiForSend(pageService: object, createGetApiMethodName: string) {
    try {
      pageService[createGetApiMethodName]()
        .pipe(this.basePipeOperators())
        .subscribe((res) => {
          if (!res) this.closeThisTab();
        });
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.baseFormPage);
    }
  }

  showErrorDialog(event: any) {
    this.#dialogService.openDialog({
      title: 'common.error',
      message: event?.errorMessage,
      status: DialogStatus.error,
    });
  }

  closeThisTab() {}
}
